import * as React from 'react'

export default () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="7" cy="7" r="7" fill="#BFA774" />
    <path d="M7 10.5V6.41663" stroke="white" strokeWidth="1.75" />
    <path d="M7 5.25V3.5" stroke="white" strokeWidth="1.75" />
  </svg>
)
